import React, { useEffect, useState } from 'react';

/**
 * High5OnCalismaIlkeleri: on.com.tr açılışında Glowy'nin On ile çalışması için High5'a sunulan çalışma ilkeleri (21 Eki 2026).
 * Route: /r/high5-on-calisma-ilkeleri (sidebar YOK, tam ekran slayt, 5 slayt 16:9, Türkçe).
 * Yeniden üretmek için: node src/pages/high5-on-calisma-ilkeleri/build.js (veri: data.py) (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~45KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function High5OnCalismaIlkeleri() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./high5OnCalismaIlkeleriHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="High5 · On Türkiye Çalışma İlkeleri"
      srcDoc={html}
      style={fill}
    />
  );
}
